module.exports = __webpack_public_path__ + "img/5.f6bcd556.webp";